export const reduceToggleMobileSidebarExpanded = (
  state,
  { payload: { expanded } },
) => ({
  ...state,
  mobileSidebarExpanded: expanded,
});
